import { Button, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import { usePlanningStore } from '@planning/AppProvider'
import { useTranslate } from '@tolgee/react'
import { FC } from 'react'

type CloseVisitDialogProps = {
  onSubmit: () => Promise<void>
}

export const CloseVisitDialog: FC<CloseVisitDialogProps> = ({ onSubmit }) => {
  const { dialogStore } = usePlanningStore()
  const { t } = useTranslate()

  return (
    <>
      <DialogTitle>{t('closeVisit', 'Close visit?')}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t(
            'closeVisitWarning',
            'The vessel visit status will be set to closed and you cannot edit the visit anymore.',
          )}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          variant='contained'
          data-cy='confirm-close-visit-btn'
          onClick={async () => {
            await onSubmit()
          }}
        >
          {t('yesClose', 'Yes, close')}
        </Button>
        <Button variant='text' color='secondary' onClick={() => dialogStore.close()}>
          {t('noKeepVisit', 'No, keep visit')}
        </Button>
      </DialogActions>
    </>
  )
}
